<div class="sample-actions-container">
  <div class="flex-row actions-strip" data-cy="analysis-sample-actions">
    <ng-container *ngIf="layout === 'mobile'; else toolbarTemplate">
      <button class="toolbar-action btn float-right" #btn [matMenuTriggerFor]="menu">
        <i fxFlex class="ri-tools-line"></i>
      </button>
      <mat-menu #menu="matMenu" class="setting-menu">
        <ng-container [ngTemplateOutlet]="toolsTemplate"></ng-container>
      </mat-menu>
    </ng-container>
    <ng-template #toolbarTemplate>
      <div class="flex-row">
        <ng-container [ngTemplateOutlet]="toolsTemplate"></ng-container>
      </div>
    </ng-template>

    <ng-template #toolsTemplate>
      <ng-container *ngIf="layout === 'web' && !mosaicMode">
        <button *ngIfRole="['admin', 'analyst', 'analystmanager']" mat-menu-item class="toolbar-action"
          [matTooltip]="'tooltip.panel_mosaics_view' | translate" [matTooltipShowDelay]="1000"
          #mosaicTooltip="matTooltip" (mouseleave)="mosaicTooltip.hide()" (click)="toggleMode.emit('mosaic')"
          data-cy="mosaics-view-button" [disabled]="mosaicButtonDisabled || busy">
          <i class="ri-grid-line"></i>
        </button>
      </ng-container>

      <!-- <ng-container *ngIf="state.layout === 'web' && mosaicMode">
        <button
          mat-menu-item
          class="toolbar-action"
          [routerLink]="[]"
          [matTooltip]="'tooltip.panel_scale_adjust' | translate"
          (click)="toggleScaleMode()"
          [ngClass]="{ applied: scaleActive }"
          data-cy="mosaic-scale-view-button"
          [disabled]="state.syncing"
        >
          <i class="ri-fullscreen-exit-line"></i>
        </button>
      </ng-container>

      <ng-container *ngIf="state.layout === 'web' && mosaicMode">
        <button
          mat-menu-item
          class="toolbar-action"
          [routerLink]="[]"
          [matTooltip]="'tooltip.panel_reference_overlay' | translate"
          (click)="toggleReferenceMode()"
          [ngClass]="{ applied: referenceActive }"
          data-cy="mosaic-reference-view-button"
          [disabled]="state.syncing"
        >
          <i class="ri-artboard-2-line"></i>
        </button>
      </ng-container> -->

      <ng-container *ngIf="layout === 'web' && !mosaicMode">
        <button *ngIfRole="['admin', 'analyst', 'analystmanager']" mat-menu-item class="toolbar-action"
          [disabled]="!hspan" [matTooltip]="'tooltip.ruler' | translate" [matTooltipShowDelay]="1000"
          #rulerTooltip="matTooltip" (mouseleave)="rulerTooltip.hide()" (click)="togglePanel(TabContext.RULER)"
          [ngClass]="{
            active: panelContext === TabContext.RULER,
            applied: rulerActive
          }" data-cy="-button">
          <i class="ri-ruler-line"></i>
        </button>
      </ng-container>

      <ng-container *ngIf="layout === 'web' && !mosaicMode">
        <button *ngIfRole="['admin', 'analyst', 'analystmanager']" mat-menu-item class="toolbar-action"
          [matTooltip]="'tooltip.panel_image_filters' | translate" [matTooltipShowDelay]="1000"
          #filtersTooltip="matTooltip" (mouseleave)="filtersTooltip.hide()" data-cy="image-filters-button" [ngClass]="{
            active: panelContext === TabContext.FILTERS,
            applied: imageFiltersApplied
          }" (click)="togglePanel(TabContext.FILTERS)">
          <i class="ri-equalizer-line"></i>
        </button>
      </ng-container>

      <ng-container *ngIf="layout === 'web' && !mosaicMode && !analystInBreadcrumb">
        <button *ngIfRole="['admin', 'analyst', 'analystmanager']" mat-menu-item class="toolbar-action"
          [disabled]="!analystStates.size" data-cy="review-other-analyst" [matTooltip]="
            isReviewingOtherAnalyst && editingEnabled && analystSelected && analystSelected.type === 'user'
              ? ('analysis.reviewing_analyst' | translate) + ': ' + analystSelected.name
              : ('tooltip.panel_analysis_review' | translate)
          " [matTooltipShowDelay]="500" #analystTooltip="matTooltip" (mouseleave)="analystTooltip.hide()" [ngClass]="{
            active: panelContext === TabContext.ANALYST,
            'reviewing-active': isReviewingOtherAnalyst && editingEnabled && analystSelected?.type === 'user'
          }" (click)="togglePanel(TabContext.ANALYST)">
          <i class="ri-group-line"></i>
          <span *ngIf="isReviewingOtherAnalyst && editingEnabled && analystSelected?.type === 'user'"
            class="review-badge"></span>
        </button>
      </ng-container>

      <ng-container *ngIf="layout === 'web' && !mosaicMode && !analystInBreadcrumb">
        <button *ngIfRole="['admin', 'analyst', 'analystmanager']" mat-menu-item class="toolbar-action"
          [disabled]="!aiAlgorithms.length" [matTooltip]="
            isReviewingOtherAnalyst && editingEnabled && analystSelected && analystSelected.type === 'algorithm'
              ? ('analysis.reviewing_analyst' | translate) + ': ' + analystSelected.name
              : ('tooltip.panel_ai' | translate)
          " [matTooltipShowDelay]="500" #aiTooltip="matTooltip" (mouseleave)="aiTooltip.hide()" [ngClass]="{
            active: panelContext === TabContext.AI,
            'reviewing-active': isReviewingOtherAnalyst && editingEnabled && analystSelected?.type === 'algorithm'
          }" (click)="togglePanel(TabContext.AI)" data-cy="tab-ai">
          <i class="ri-robot-line"></i>
          <span *ngIf="isReviewingOtherAnalyst && editingEnabled && analystSelected?.type === 'algorithm'"
            class="review-badge"></span>
        </button>
      </ng-container>

      <ng-container
        *ngIf="layout === 'web' && !mosaicMode && analystInBreadcrumb && isReviewingOtherAnalyst && !aiAnalysisViewOnly">
        <button *ngIfRole="['admin', 'analyst', 'analystmanager']" mat-menu-item class="toolbar-action"
          [disabled]="syncing" [ngClass]="{ applied: editingEnabled }" [matTooltip]="
            (editingEnabled ? 'analysis.disable_editing_tooltip' : 'analysis.enable_editing_tooltip') | translate
          " [matTooltipShowDelay]="1000" #editingTooltip="matTooltip" (mouseleave)="editingTooltip.hide()"
          (click)="toggleEditing.emit(!editingEnabled)" data-cy="toolbar-toggle-editing">
          <i class="ri-edit-line" *ngIf="!editingEnabled"></i>
          <i class="ri-edit-fill" *ngIf="editingEnabled"></i>
        </button>
      </ng-container>

      <ng-container
        *ngIf="layout === 'web' && !mosaicMode && analystInBreadcrumb && isReviewingOtherAnalyst && !aiAnalysisViewOnly && !hasUnsavedData">
        <button *ngIfRole="['admin', 'analyst', 'analystmanager']" mat-menu-item class="toolbar-action"
          [disabled]="syncing" [matTooltip]="'info.accept_complete_analysis_tooltip' | translate"
          [matTooltipShowDelay]="1000" #acceptTooltip="matTooltip" (mouseleave)="acceptTooltip.hide()"
          (click)="acceptCompleteAnalysis.emit()" data-cy="toolbar-accept-analysis">
          <i class="ri-checkbox-circle-line"></i>
        </button>
      </ng-container>

      <ng-container *ngIf="selectedAsset && !mosaicMode">
        <button mat-menu-item class="toolbar-action" [disabled]="!downloadAvailable"
          matTooltip="{{ 'button.download_original_image' | translate }}" [matTooltipShowDelay]="1000"
          #downloadTooltip="matTooltip" (mouseleave)="downloadTooltip.hide()" (click)="downloadSelectedAsset()"
          data-cy="button-download-asset">
          <i class="ri-download-2-line"></i>
        </button>
      </ng-container>

      <ng-container *ngIf="layout !== 'mobile' && numAssets > 1 && !mosaicMode">
        <button mat-menu-item class="toolbar-action" [disabled]="!downloadAvailable"
          matTooltip="{{ 'button.download_zip_images' | translate }}" [matTooltipShowDelay]="1000"
          #zipTooltip="matTooltip" (mouseleave)="zipTooltip.hide()" (click)="onDownloadAllClick($event)"
          data-cy="button-download-assets-zip">
          <i class="ri-folder-download-line"></i>
        </button>
      </ng-container>

      <ng-container *ngIf="layout === 'web'">
        <button [disabled]="syncing || !hasUnsavedData" mat-menu-item class="toolbar-action"
          matTooltip="{{ 'button.save' | translate }}" [matTooltipShowDelay]="1000" #saveTooltip="matTooltip"
          (mouseleave)="saveTooltip.hide()" [class.bg-warning]="hasUnsavedData && !syncing"
          [class.text-white]="hasUnsavedData" (click)="save.emit()" *ngIfRole="['admin', 'analyst', 'analystmanager']"
          data-cy="toolbar-save-analysis">
          <mat-spinner *ngIf="syncing; else saveIcon" class="relative-spinner" value="indeterminate"
            [diameter]="20"></mat-spinner>
          <ng-template #saveIcon>
            <i class="ri-save-line"></i>
          </ng-template>
        </button>
      </ng-container>

      <ng-container *ngIf="layout === 'web'">
        <button *ngIfRole="['admin', 'analyst', 'analystmanager']" mat-menu-item class="toolbar-action"
          [matTooltip]="'analysis.revert_all_changes' | translate" [disabled]="!hasUnsavedData || !canEdit"
          (click)="revertAllChanges.emit()" data-cy="toolbar-revert-all-changes">
          <i class="ri-arrow-go-back-line"></i>
        </button>
      </ng-container>

      <ng-container *ngIf="layout === 'web'">
        <button mat-menu-item class="toolbar-action" matTooltip="{{ 'button.close' | translate }}"
          [matTooltipShowDelay]="1000" #exitTooltip="matTooltip" (mouseleave)="exitTooltip.hide()" [disabled]="busy"
          (click)="exit.emit()" data-cy="toolbar-exit">
          <i class="ri-close-fill"></i>
        </button>
      </ng-container>
    </ng-template>
  </div>

  <mat-expansion-panel class="custom-mat-expansion-panel" #actionExpPanel="matExpansionPanel"
    [expanded]="isActionPanelOpen">
    <ng-container [ngSwitch]="panelContext">
      <ng-container *ngSwitchCase="'ai'">
        <div class="action-panel" *ngIf="!analystInBreadcrumb">
          <ts-ai-analysis-in-progress-banner [visible]="sectorProcessing || aiAnalysisStatus === 'error'"
            [pollingExhausted]="aiPollingExhausted"
            [error]="aiAnalysisStatus === 'error'"></ts-ai-analysis-in-progress-banner>
          <ts-ai-analysis-selection-panel [editMode]="isAnalystCurrentUser && !aiAnalysisViewOnly"
            [aiAlgorithms]="aiAlgorithms" [analysisStates]="analystStates" [analystSelected]="analystSelected"
            [aiAnalysisStatus]="aiAnalysisStatus" [editingEnabled]="editingEnabled"
            (analystChange)="analystChange.emit($event)">
          </ts-ai-analysis-selection-panel>

          <!-- Editing Toggle Button -->
          <div *ngIf="isReviewingOtherAnalyst && !aiAnalysisViewOnly" class="editing-toggle-container">
            <button mat-stroked-button [color]="editingEnabled ? 'accent' : 'primary'" [disabled]="syncing"
              (click)="toggleEditing.emit(!editingEnabled)" [matTooltip]="
                editingEnabled
                  ? ('analysis.disable_editing_tooltip' | translate)
                  : ('analysis.enable_editing_tooltip' | translate)
              " class="editing-toggle-button" data-cy="ai-panel-toggle-editing">
              <i class="ri-edit-line" *ngIf="!editingEnabled"></i>
              <i class="ri-edit-fill" *ngIf="editingEnabled"></i>
              <span class="ml-2">
                {{
                editingEnabled ? ('analysis.disable_editing' | translate) : ('analysis.enable_editing' | translate)
                }}
              </span>
            </button>
            <button *ngIf="!hasUnsavedData" mat-raised-button color="accent" [disabled]="syncing"
              (click)="acceptCompleteAnalysis.emit()" class="accept-analysis-button"
              [matTooltip]="'info.accept_complete_analysis_tooltip' | translate" data-cy="panel-accept-analysis-ai">
              <i class="ri-checkbox-circle-line accept-icon"></i>
              <span class="accept-text">{{ 'button.accept_complete_analysis' | translate }}</span>
            </button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'analyst'">
        <div class="action-panel" *ngIf="!analystInBreadcrumb">
          <ts-analyst-selector [isCurrentUser]="isAnalystCurrentUser" [analystSelected]="analystSelected"
            [analysts]="userAnalysts" [analysisStates]="analystStates" [editingEnabled]="editingEnabled"
            (analystChange)="analystChange.emit($event)"
            (toogleReference)="toogleReference.emit()"></ts-analyst-selector>

          <!-- Editing Toggle Button -->
          <div *ngIf="isReviewingOtherAnalyst && !aiAnalysisViewOnly" class="editing-toggle-container">
            <button mat-stroked-button [color]="editingEnabled ? 'accent' : 'primary'" [disabled]="syncing"
              (click)="toggleEditing.emit(!editingEnabled)" [matTooltip]="
                editingEnabled
                  ? ('analysis.disable_editing_tooltip' | translate)
                  : ('analysis.enable_editing_tooltip' | translate)
              " class="editing-toggle-button" data-cy="tools-toggle-editing">
              <i class="ri-edit-line" *ngIf="!editingEnabled"></i>
              <i class="ri-edit-fill" *ngIf="editingEnabled"></i>
              <span class="ml-2">
                {{
                editingEnabled ? ('analysis.disable_editing' | translate) : ('analysis.enable_editing' | translate)
                }}
              </span>
            </button>

            <button *ngIf="!hasUnsavedData" mat-raised-button color="accent" [disabled]="syncing"
              (click)="acceptCompleteAnalysis.emit()" class="accept-analysis-button"
              [matTooltip]="'info.accept_complete_analysis_tooltip' | translate" data-cy="panel-accept-analysis">
              <i class="ri-checkbox-circle-line accept-icon"></i>
              <span class="accept-text">{{ 'button.accept_complete_analysis' | translate }}</span>
            </button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'ruler'">
        <div class="action-panel">
          <ts-ruler-selector [rulerIcon]="rulerIcon" [rulerSize]="rulerSize"
            (changeRulerIcon)="changeRulerIcon.emit($event)" (changeRulerSize)="changeRulerSize.emit($event)"
            (resetRuler)="resetRuler.emit()"></ts-ruler-selector>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'filters'">
        <div class="action-panel">
          <ts-image-filters [filters]="imageFilters" [selectedPreset]="selectedPreset"
            (updateFilter)="updateFilter.emit($event)" (presetFilters)="updateFilters.emit($event)"
            (resetFilters)="resetFilters.emit()"></ts-image-filters>
        </div>
      </ng-container>
    </ng-container>
  </mat-expansion-panel>
</div>
